export const twDiv = (strings: any, ...values: any) =>
    ({children}: any) => (<div className={strings.raw[0]}>{children}</div>)
export const twP = (strings: any, ...values: any) =>
    ({children}: any) => (<p className={strings.raw[0]}>{children}</p>)
export const twSpan = (strings: any, ...values: any) =>
    ({children}: any) => (<span className={strings.raw[0]}>{children}</span>)
export const twLi = (strings: any, ...values: any) =>
    ({children}: any) => (<li className={strings.raw[0]}>{children}</li>)
